import { FC } from 'react'

type ImageProps = {
  src: string
  alt: string
}

// 
export const Image: FC<ImageProps> = ({ src, alt }) => {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="rounded object-cover h-[175px] w-[175px] max-w-[233px] md:h-[233px] md:w-[233px] md:max-w-[233px] lg:h-[233px] lg:w-[233px] lg:max-w-[233px]"
    />
  )
}
